import * as React from "react";

import { InputPhone } from "../../components/molecules";
import { codesData } from "../../static/country-telephone-codes";

export interface IPhoneNumberObject {
  codeIndex: number;
  dialCode: string;
  fullPhoneNumber: string;
  phoneNumber: string;
}

interface IProps {
  preselectedPhoneNumber?: string;
  preselectedCodeIndex?: number;
  disabled?: boolean;
  onNumberChange(object: IPhoneNumberObject): void;
}

interface IState {
  isFocused: boolean;
  phoneNumber?: string;
  selectedCodeIndex?: number;
  selectedDialCode?: string;
}

const GB_INDEX = 187;

class InputPhoneCodeContainer extends React.Component<IProps, IState> {
  private readonly inputRef = React.createRef<HTMLInputElement>();
  private readonly selectRef = React.createRef<HTMLSelectElement>();

  private readonly preselectedCodeIndex =
    this.props.preselectedCodeIndex || GB_INDEX;

  public state = {
    isFocused: false,
    // tslint:disable-next-line: strict-boolean-expressions
    phoneNumber: this.props.preselectedPhoneNumber || "",
    selectedCodeIndex: this.preselectedCodeIndex,
    selectedDialCode: codesData[this.preselectedCodeIndex].dial_code,
  };

  public componentDidUpdate(prevProps: IProps) {
    if (
      prevProps.preselectedPhoneNumber !== this.props.preselectedPhoneNumber &&
      prevProps.preselectedCodeIndex !== this.props.preselectedCodeIndex
    ) {
      this.setState({
        phoneNumber: this.props.preselectedPhoneNumber,
        selectedCodeIndex: this.props.preselectedCodeIndex,
        ...(this.props.preselectedCodeIndex && {
          selectedDialCode:
            codesData[this.props.preselectedCodeIndex].dial_code,
        }),
      });
    }
  }

  /**
   * List of countries phone codes
   */
  public mapPhoneCodes() {
    return codesData.map((value, index) => {
      return (
        <option value={index} key={index}>
          {value.name} ({value.dial_code})
        </option>
      );
    });
  }

  public selectCode = (value: string) => {
    if (this.inputRef.current) {
      this.inputRef.current.focus();
    }

    const selectedCodeIndex = parseInt(value, 10);

    this.setState({
      selectedCodeIndex,
      selectedDialCode: codesData[selectedCodeIndex].dial_code,
    });

    this.setPhoneNumber(this.state.phoneNumber);
  };

  public wrapperClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target !== this.selectRef.current && this.inputRef.current) {
      this.inputRef.current.focus();
    }
  };

  /**
   * Replace any non-digit and first 00 zeros of international format
   */
  public setPhoneNumber = (value: string) => {
    const phoneNumber: string = value.replace(/\D|^[0]{2}/gi, "");

    this.setState({ phoneNumber }, () => {
      const dialCode = this.state.selectedDialCode;
      const codeIndex = this.state.selectedCodeIndex;
      const fullPhoneNumber = `${dialCode}${phoneNumber}`;

      this.props.onNumberChange({
        codeIndex,
        dialCode,
        fullPhoneNumber,
        phoneNumber,
      });
    });
  };

  public toggleFocus = () => {
    this.setState({ isFocused: !this.state.isFocused });
  };

  // tslint:disable-next-line: completed-docs
  public render() {
    return (
      <InputPhone
        isFocused={this.state.isFocused}
        onCodeSelect={this.selectCode}
        onPhoneInput={this.setPhoneNumber}
        onToggleFocus={this.toggleFocus}
        onWrapperClick={this.wrapperClick}
        phoneNumber={this.state.phoneNumber}
        selectedCodeIndex={this.state.selectedCodeIndex}
        selectedDialCode={this.state.selectedDialCode}
        inputRef={this.inputRef}
        selectRef={this.selectRef}
        disabled={this.props.disabled}
      >
        {this.mapPhoneCodes()}
      </InputPhone>
    );
  }
}

export { InputPhoneCodeContainer };
